import React from "react";
import { useTranslation } from "react-i18next";
import { ShimmerDiv } from "./ThemedShimmer";

const ResumeSectionSkeleton = ({ rows = 2 }) => (
  <div className="px-3 pb-3">
    <ShimmerDiv height={20} width={160} rounded={4} className="mb-3" />
    {Array.from({ length: rows }, (_, index) => (
      <ShimmerDiv
        key={`view-resume-section-row-${index}`}
        className="mb-3"
        height={88}
        width="100%"
        rounded={8}
      />
    ))}
  </div>
);

const ViewResumeSkeleton = ({ className = "" }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`user-resume UpdateProfile ${className}`.trim()}
      role="status"
      aria-busy="true"
      aria-label={t("Common.LoadingResume")}
    >
      <span className="skeleton-screen-reader-only">{t("Common.LoadingResume")}</span>
      <div className="resume-header d-flex align-items-center px-3 py-3">
        <ShimmerDiv height={72} width={72} rounded={50} />
        <div className="ms-3 flex-grow-1">
          <ShimmerDiv height={28} width={220} rounded={4} className="mb-2" />
          <ShimmerDiv height={18} width={140} rounded={4} />
        </div>
        <div className="d-flex ms-auto gap-2">
          <ShimmerDiv height={50} width={50} rounded={4} />
          <ShimmerDiv height={50} width={50} rounded={4} />
        </div>
      </div>
      <div className="row border-custom2 px-3 pb-2">
        {Array.from({ length: 6 }, (_, index) => (
          <div className="col-md-6 border-custom p-2" key={`view-resume-field-${index}`}>
            <ShimmerDiv height={14} width={72} rounded={4} className="mb-2" />
            <ShimmerDiv height={18} width="75%" rounded={4} />
          </div>
        ))}
      </div>
      <ShimmerDiv className="mx-3 mb-3" height={56} width="95%" rounded={8} />
      <ResumeSectionSkeleton rows={2} />
      <ResumeSectionSkeleton rows={2} />
      <ResumeSectionSkeleton rows={1} />
    </div>
  );
};

export default ViewResumeSkeleton;
